module.exports = __webpack_public_path__ + "static/media/freelancer-static-hero.b0921f2a.png";